import { useRef } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

/**
 * Wraps any child in a magnetic pull effect — the element shifts toward
 * the cursor when nearby, snapping back on mouse leave.
 * strength controls max pixel displacement.
 */
const MagneticButton = ({ children, strength = 28, className = '' }) => {
  const ref = useRef(null);
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const x = useSpring(rawX, { stiffness: 260, damping: 22 });
  const y = useSpring(rawY, { stiffness: 260, damping: 22 });

  const onMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = e.clientX - cx;
    const dy = e.clientY - cy;
    rawX.set(dx * (strength / (rect.width / 2)));
    rawY.set(dy * (strength / (rect.height / 2)));
  };

  const onLeave = () => {
    rawX.set(0);
    rawY.set(0);
  };

  return (
    <motion.div
      ref={ref}
      style={{ x, y }}
      className={className}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
    >
      {children}
    </motion.div>
  );
};

export default MagneticButton;
